import { Component, Inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { BankingService } from '../../features/banking/services/banking.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ChartOfAccountsService } from '../../features/chart-of-accounts/services/chart-of-accounts.service';

@Component({
  selector: 'app-create-transaction-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatTabsModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatRadioModule,
  ],
  templateUrl: './create-transaction-dialog.component.html',
  styleUrl: './banking-details.component.scss'
})
export class CreateTransactionDialog {
  accountType: any;
  search: any;
  parentAccountId: any;
  isSubAccount: any;
  chartOfAccounts: any;
  createTransactionForm: FormGroup;
  bankId: any;
  type: any;
  categoryId: any;
  categories: any;
  expenseId: any;
  otherIncomeId: any;
  pendingAmount: any;

  constructor(
    private chartAccountService: ChartOfAccountsService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private bankingService: BankingService,
    private router: Router,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateTransactionDialog>
  ) {}

  ngOnInit() {
    this.createTransactionForm = this.fb.group({
      applyTo: ['', Validators.required],
      date: ['', Validators.required],
      amount: ['', Validators.required],
      reference: [''],
    });

    this.initForm();
  }

  initForm() {
    console.log(this.data);
    this.bankId = this.data?.bankId;

    if (this.data) {
      this.pendingAmount = this.data?.pendingAmount;
      this.createTransactionForm.patchValue({
        applyTo: this.data?.applyTo || '',
        date: this.data.statementDate
          ? new Date(parseInt(this.data.statementDate.toString(), 10))
          : '',
        amount: '',
        reference: '',
      });
    }
  }

  onSave() {
    if (this.createTransactionForm.invalid) {
      this.createTransactionForm.markAllAsTouched();
      return;
    }

    if (this.createTransactionForm.value.applyTo === 'Deposits') {
      this.type = 'Credit';
      this.categoryId = this.otherIncomeId;
    } else if (this.createTransactionForm.value.applyTo === 'Withdrawals') {
      this.type = 'Debit';
      this.categoryId = this.expenseId;
    }

    const formValue = this.createTransactionForm.value;
    const createBankTransactionInput = {
      bankAccountId: Number(this.bankId),
      transactionType: this.type,
      amount: parseFloat(formValue.amount),
      transactionDate: formValue.date,
      referenceNumber: formValue.reference,
    };

    this.bankingService
      .createBankTransaction(createBankTransactionInput)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.toastr.success('Transaction successfully added');
          this.dialogRef.close();
        },
        error: (err) => {
          this.toastr.error(err?.message);
          console.log(err);
        },
      });
  }
}